// extracted by mini-css-extract-plugin
export var marker = "MarkedTitle-module--marker--d4e00";
export var program = "MarkedTitle-module--program--6fdf2";
export var root = "MarkedTitle-module--root--aacaa";
export var speakers = "MarkedTitle-module--speakers--c2199";
export var topics = "MarkedTitle-module--topics--17d72";